const $ = require("jquery")
require("daterangepicker")
const moment = require("moment")
const Rellax = require('rellax')
const gsap = require('gsap').gsap
const barba = require('@barba/core')
const LazyLoad = require("vanilla-lazyload")
import {
    tns
} from 'tiny-slider/src/tiny-slider';
import AOS from 'aos';
const route = require("./routeLoad.js")

function delay(n) {
    n = n || 2000;
    return new Promise(done => {
        setTimeout(() => {
            done();
        }, n);
    });
}


function pageTransition() {
    var tl = gsap.timeline();
    tl.set('.loading-screen', {
        transformOrigin: "bottom left"
    });
    tl.to('.loading-screen', {
        duration: .5,
        scaleY: 1
    });
    tl.to('.loading-screen', {
        duration: .5,
        scaleY: 0,
        skewX: 0,
        transformOrigin: "top left",
        ease: "power1.out",
        delay: 1
    });
}

// Function to animate the content of each page
function contentAnimation() {

    var tl = gsap.timeline();
    tl.from('.is-animated', {
        duration: .5,
        translateY: 10,
        opacity: 0,
        stagger: 0.4
    });
    tl.from('.main-navigation', {
        duration: .5,
        translateY: -10,
        opacity: 0
    });

    $('.green-heading-bg').addClass('show');

}



$(function() {
    window.barba = barba;
    barba.init({
        sync: true,
        debug: true,
        timeout: 5000,
        transitions: [{
            async leave(data) {
                // alert('data.current.namespace',data)
                console.log('data', data.current.namespace)

                if (data.current.namespace.includes('cadastro') || data.current.namespace.includes('etapa')) {
                    // no animationno
                    const done = this.async();
                    done();
                } else {
                    pageTransition();
                    const done = this.async();

                    await delay(1000);
                    done();
                }

            },
            async enter(data) {
                history.scrollRestoration = 'manual';
                window.scrollTo(0, 0)

                try {

                    //load components by page
                    await route.routeLoad(data.next.namespace)
                    // load componnets in all pages
                    var menu = await require(`../views/components/menu/menu.script`);
                    var newsletter = await require(`./newsletter`);

                    await menu.start();
                    await newsletter.start();
                    await contentAnimation();



                } catch (err) {
                    console.log('err', err)


                    return err
                }
            },
            async once(data) {
                await route.routeLoad(data.next.namespace)
                var menu = await require(`../views/components/menu/menu.script`);
                var newsletter = await require(`./newsletter`);

                await menu.start()
                await contentAnimation();
                await newsletter.start();
            },
            async after(data) {
                try {
                    await route.routeOffload(data.current.namespace)
                } catch (err) {

                    console.log('err', err)
                    return err
                }
            },
        }]
    });
});





document.addEventListener('DOMContentLoaded', removeLoadingScreen(), false);




async function removeLoadingScreen() {
    await delay(500);
    if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('js/sw.js')
    .then(reg => console.info('registered sw', reg))
    .catch(err => console.error('error registering sw', err));
}

    AOS.init();

    var loadingEl = document
        .getElementById("loading-screen-pre")
        .classList
        .add("done");
    return
}
